// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:16
import { FeatureInfoRequestResult_abstract } from './../abstract/SagaBase/FeatureInfoRequestResult_abstract';
export class FeatureInfoRequestResult extends FeatureInfoRequestResult_abstract {}
